import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-module"]
const _hoisted_2 = { class: "module_title" }

import { ref } from "vue";
import ExpandButton from "./ModuleDataComponents/ExpandButton.vue";
import ModuleDataTable from "./ModuleDataComponents/ModuleDataTable.vue";


export default /*#__PURE__*/_defineComponent({
  props: { list: Object },
  setup(__props) {




const expanded = ref("")


return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (result, module) => {
    return (_openBlock(), _createElementBlock("div", {
      key: module,
      class: _normalizeClass(expanded.value == module ? module + '-container module expanded' : module + '-container module')
    }, [
      (result.length > 0)
        ? _renderSlot(_ctx.$slots, "default", { key: 0 }, () => [
            _createElementVNode("div", {
              class: "module",
              "data-module": module.toString().toLowerCase()
            }, [
              _createElementVNode("div", _hoisted_2, _toDisplayString(module), 1),
              _createVNode(ModuleDataTable, {
                result: result,
                module: module
              }, null, 8, ["result", "module"]),
              (result.length > 4)
                ? _renderSlot(_ctx.$slots, "default", { key: 0 }, () => [
                    _createVNode(ExpandButton, {
                      onClick: ($event: any) => (expanded.value == module ? expanded.value = '' : expanded.value = module),
                      expandedState: expanded.value == module ? true : false,
                      module: module
                    }, null, 8, ["onClick", "expandedState", "module"])
                  ])
                : _createCommentVNode("", true)
            ], 8, _hoisted_1)
          ])
        : _createCommentVNode("", true)
    ], 2))
  }), 128))
}
}

})